(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-slideshow')) {
    customElements.define(
      'custom-slideshow',
      class CustomSlideshow extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.current = 0;
          this.speed = parseInt(this.dataset.speed, 10) || 4000;
          this.autoplay =
            this.dataset.autoplay === 'true' &&
            this.slides.length > 1 &&
            !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.current - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.current + 1));
          this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.sync());
          }, { passive: true });

          this.track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') this.go(this.current - 1);
            if (e.key === 'ArrowRight') this.go(this.current + 1);
          });

          // Pause while the user is interacting
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          this.addEventListener('touchstart', () => this.stop(), { passive: true });

          // Shopify theme editor
          this.addEventListener('shopify:block:select', (e) => {
            const i = this.slides.indexOf(e.target);
            if (i > -1) this.go(i, true);
            this.editorSelected = true;
            this.stop();
          });
          this.addEventListener('shopify:block:deselect', () => {
            this.editorSelected = false;
            this.start();
          });

          this.start();
        }

        disconnectedCallback() {
          this.stop();
          cancelAnimationFrame(this.raf);
        }

        go(index, instant = false) {
          const total = this.slides.length;
          const target = (index + total) % total;
          this.track.scrollTo({
            left: target * this.track.clientWidth,
            behavior: instant ? 'auto' : 'smooth',
          });
        }

        sync() {
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (index === this.current) return;
          this.current = index;
          this.dots.forEach((dot, i) => {
            if (i === index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }

        start() {
          if (!this.autoplay || this.editorSelected) return;
          this.stop();
          this.timer = setInterval(() => this.go(this.current + 1), this.speed);
        }

        stop() {
          clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
